/*
    © 2021 EcomGraduates.com. All rights reserved.
    https://www.ecomgraduates.com
*/

/*
    IMPORTANT: Through that you may directly work on this file,
    we recommend that you create a new JavaScript file
    "asset/custom.js" and add all your scripts there. In this way,
    it will be easier for you to update our theme.
*/

// Logo option element
let firstField = false;
let secondField = false;
let thirdField = false;
let disableCartButton = true;

const removeActivePageLogoOptions = () => {
  const pageLogoOptions = [...document.querySelectorAll('.page-logo-option')];
  pageLogoOptions.forEach((text) => {
    text.classList.remove('active');
    text.closest('.option-buttons__item').classList.remove('active');
  });
}

const clearInputValues = (fields) => {
  fields.forEach(field => {
    switch(field.type) {
      case 'file':
      case 'text':
      case 'textarea':
        field.value = '';
        break;
      case 'checkbox':
        field.checked = false;
        break;
    }
  });

  firstField = false;
  secondField = false;
  thirdField = false;
  disableCartButton = true;
}

// Product options 
document.querySelectorAll(".product-option").forEach((optionEl) => {
  const form = optionEl.closest('form[action="/cart/add"]');
  const styleSelect = form.querySelector('#option-style');
  const sleeveImageInput = form.querySelector('input[name="properties[select-sleeve]"]');
  const colorsInputs = form.querySelectorAll('input[name="color"]') || form.querySelectorAll('input[name="colors"]');
  const frontPropertiesInput = form.querySelector('input[name="properties[select-front]"]');
  const backPropertiesInput = form.querySelector('input[name="properties[select-back]"]');

  if (colorsInputs && window.front_colors_images && window.back_colors_images && frontPropertiesInput && backPropertiesInput) {
    colorsInputs.forEach((colorInput) => {
      colorInput.addEventListener("change", (e) => {
        const value = e.target.value;
        frontPropertiesInput.value = window.front_colors_images[value];
        backPropertiesInput.value = window.back_colors_images[value];
      });
    });
  }

  if (styleSelect && sleeveImageInput && window.styles_sleeve_images) {
    styleSelect.addEventListener("change", (e) => {
      const value = e.target.value.toLowerCase().replaceAll(' ', '-');
      sleeveImageInput.value = window.styles_sleeve_images[value];
    });
  }

  optionEl.addEventListener("change", () => {
    const selectedOptions = [];
    const logoInputs = form.querySelectorAll("#product-form-logo-logo-list input");

    form.querySelectorAll(".product-option").forEach((optionEl2) => {
      if (optionEl2.type === "radio") {
        if (optionEl2.checked) {
          selectedOptions.push(optionEl2.value);
        }
      } else {
        selectedOptions.push(optionEl2.value);
      }
    });

    const selectedVariant = JSON.parse(form.dataset.variants).find(
      (variant) =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    ) || JSON.parse(form.dataset.variants).find(variant => variant.option1.includes(selectedOptions[0]));

    const addToCartBtn = form.querySelector(".btn-atc");
    const buyItNowBtn = form.querySelector(".btn-buy-it-now");
    const artworkLookupInput = document.getElementById(
      "product-form-input-order-no"
    );
    const artworkNotAvailable = document.querySelector("#artwork-details-card-not-available") ? document.querySelector("#artwork-details-card-not-available").getAttribute("style") === "display: block;" : false;
    const artworkCancelled = document.querySelector("#artwork-details-card-cancelled") ? document.querySelector("#artwork-details-card-cancelled").getAttribute("style") === "display: block;" : false;
    const artworkError = window.localStorage.getItem("artwork-order-id-error");

    if (selectedVariant) {
      form.querySelector('select[name="id"]').value = selectedVariant.id;
      
      // Update the central state with variant availability
      if (window.productFormState) {
        window.productFormState.variant.available = selectedVariant.available && !artworkCancelled && !artworkNotAvailable;
        
        // Update size and color states
        const sizeInput = form.querySelector('input[name="size"]:checked');
        const colorInput = form.querySelector('input[name="color"]:checked');
        const colorsInput = form.querySelector('input[name="colors"]:checked');
        window.productFormState.requiredSelections.size = !!sizeInput;
        window.productFormState.requiredSelections.color = !!colorInput;
        window.productFormState.requiredSelections.colors = !!colorsInput;
        
        // Check the button state using our central logic
        window.productFormState.checkButtonState(form);
      } else {
        // Fallback to previous logic if central state isn't available
        if (artworkLookupInput) {
          if (selectedVariant.available && !artworkCancelled && !artworkNotAvailable) {
            addToCartBtn.disabled = false;
            if (buyItNowBtn) {
              buyItNowBtn.disabled = false;
            }
            addToCartBtn.textContent = addToCartBtn.dataset.textAddToCart;
          } else {
            addToCartBtn.disabled = true;
            if (buyItNowBtn) {
              buyItNowBtn.disabled = true;
            }
            if (selectedVariant.available) {
              addToCartBtn.textContent = addToCartBtn.dataset.textUnavailable;
            } else {
              addToCartBtn.textContent = addToCartBtn.dataset.textSoldOut;
            }
          }
        } else {
          // Handle artwork selection checks in the old way if central state isn't available
          const selectedArtwork = form.querySelector('input[name^="properties[select-"]:checked');
          const sizeSelected = form.querySelector('input[name="size"]:checked') || form.querySelector('select[name="size"] option:checked');
          const colorSelected = form.querySelector('input[name="color"]:checked') || form.querySelector('select[name="color"] option:checked') || form.querySelector('input[name="colors"]:checked');
          if (selectedArtwork && sizeSelected && colorSelected) {
            addToCartBtn.disabled = false;
            if (buyItNowBtn) {
              buyItNowBtn.disabled = false;
            }
            addToCartBtn.textContent = addToCartBtn.dataset.textAddToCart;
          } else {
            addToCartBtn.disabled = true;
            if (buyItNowBtn) {
              buyItNowBtn.disabled = true;
            }
            if (!sizeSelected && !colorSelected) {
              addToCartBtn.textContent = addToCartBtn.dataset.textSelectSizeAndColor;
            } else if (!sizeSelected) {
              addToCartBtn.textContent = addToCartBtn.dataset.textSelectSize;
            } else if (!colorSelected) {
              addToCartBtn.textContent = addToCartBtn.dataset.textSelectColor;
            } else {
              addToCartBtn.textContent = selectedVariant && selectedVariant.available ? addToCartBtn.dataset.textUnavailable : addToCartBtn.dataset.textSoldOut;
            }
          }
        }
      }

      const productPriceContainer = document.querySelector(
        `.product-price-container[data-product-id="${form.dataset.productId}`
      );

      productPriceContainer.querySelector(".product-price-final").textContent =
        window.formatMoney(selectedVariant.price);

      if (selectedVariant.compare_at_price) {
        productPriceContainer.querySelector(
          ".product-price-compare"
        ).textContent = window.formatMoney(selectedVariant.compare_at_price);
        productPriceContainer
          .querySelector(".product-price-compare")
          .classList.remove("d-none");
      } else {
        productPriceContainer
          .querySelector(".product-price-compare")
          .classList.add("d-none");
      }

      document.dispatchEvent(new CustomEvent('product-option-change', {
        detail: {
          variant: selectedVariant,
          form: form
        }
      }));

      window.history.replaceState(
        {},
        "",
        `${form.dataset.productUrl}?variant=${selectedVariant.id}`
      );

      if (selectedVariant.featured_media) {
        bootstrap.Carousel.getInstance("#product-carousel").to(
          selectedVariant.featured_media.position - 1
        );
      }
    } else {
      // Update the central state when no variant is selected
      if (window.productFormState) {
        window.productFormState.variant.available = false;
        window.productFormState.checkButtonState(form);
      } else {
        // Fallback to previous logic if central state isn't available
        addToCartBtn.disabled = true;
        if (buyItNowBtn) {
          buyItNowBtn.disabled = true;
        }

        if (form) {
          const sizeSelected = form.querySelector('input[name="size"]:checked') || form.querySelector('select[name="size"] option:checked');
          const colorSelected = form.querySelector('input[name="color"]:checked') || form.querySelector('select[name="color"] option:checked') || form.querySelector('input[name="colors"]:checked');
          if (sizeSelected || colorSelected) {
            if (!sizeSelected && !colorSelected) {
              addToCartBtn.textContent = addToCartBtn.dataset.textSelectSizeAndColor;
            } else if (!sizeSelected) {
              addToCartBtn.textContent = addToCartBtn.dataset.textSelectSize;
            } else if (!colorSelected) {
              addToCartBtn.textContent = addToCartBtn.dataset.textSelectColor;
            } else {
              addToCartBtn.textContent = addToCartBtn.dataset.textUnavailable;
            }
          }
        }

        // Check if there's a selected artwork before disabling the button
        const selectedArtwork = form.querySelector('input[name^="properties[select-"]:checked');
        const sizeSelected = form.querySelector('input[name="size"]:checked') || form.querySelector('select[name="size"] option:checked');
        const colorSelected = form.querySelector('input[name="color"]:checked') || form.querySelector('select[name="color"] option:checked') || form.querySelector('input[name="colors"]:checked');
        if (selectedArtwork && sizeSelected && colorSelected) {
          addToCartBtn.disabled = false;
          if (buyItNowBtn) {
            buyItNowBtn.disabled = false;
          }
          addToCartBtn.textContent = addToCartBtn.dataset.textAddToCart;
        } else {
          addToCartBtn.disabled = true;
          if (buyItNowBtn) {
            buyItNowBtn.disabled = true;
          }
          if (!sizeSelected && !colorSelected) {
            addToCartBtn.textContent = addToCartBtn.dataset.textSelectSizeAndColor;
          } else if (!sizeSelected) {
            addToCartBtn.textContent = addToCartBtn.dataset.textSelectSize;
          } else if (!colorSelected) {
            addToCartBtn.textContent = addToCartBtn.dataset.textSelectColor;
          } else {
            addToCartBtn.textContent = selectedVariant && selectedVariant.available ? addToCartBtn.dataset.textUnavailable : addToCartBtn.dataset.textSoldOut;
          }
        }

        window.history.replaceState({}, "", (window.product && window.product.url) ? window.product.url : window.location.pathname);
      }
    }

    if (logoInputs.length > 0) {
      const checkedLogoInputs = form.querySelectorAll("#product-form-logo-logo-list input:checked");
      const addToCartButton = form.querySelector('.btn-atc');

      addToCartButton.disabled = checkedLogoInputs.length < 1;
    }
  });
});


// Product options DS
document.querySelectorAll(".option-buttons-ds").forEach((optionEl) => {
  optionEl.addEventListener("change", () => {
    const form = optionEl.closest('form[action="/cart/add"]');
    const selectedOptions = [];
    const logoInputs = form.querySelectorAll("#product-form-logo-logo-list input");

    const selectedOption = optionEl.options[optionEl.selectedIndex];

    form.querySelectorAll(".product-option-ds").forEach((optionEl2) => {
      if (optionEl2.selected) {
        if (optionEl2.value == selectedOption.value) {
          selectedOptions.push(optionEl2.value);
        }
      }
    });

    const selectedVariant = JSON.parse(form.dataset.variants).find(
      (variant) =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    );

    const addToCartBtn = form.querySelector(".btn-atc");
    const buyItNowBtn = form.querySelector(".btn-buy-it-now");
    const artworkLookupInput = document.getElementById(
      "product-form-input-order-no"
    );
    const artworkError = window.localStorage.getItem("artwork-order-id-error");

    if (selectedVariant) {
      const pageLogoOptions = [...document.querySelectorAll('.page-logo-option')];

      if (pageLogoOptions.length > 0) {
        removeActivePageLogoOptions();
        const transformedString = "option-" + selectedVariant.title.replace(/ /g, "-");

        pageLogoOptions.forEach((logoOption) => {
          if (logoOption.dataset.optionName == transformedString) {
            logoOption.classList.add('active');
            logoOption.closest('.option-buttons__item').classList.add('active');

            const addToCartBtn = form.querySelector(".btn-atc");

            if (!disableCartButton && firstField && secondField && thirdField) {
              addToCartBtn.disabled = false;
            } else {
              addToCartBtn.disabled = true;
            }
          }
        })
      }

      form.querySelector('select[name="id"]').value = selectedVariant.id;
      if (artworkLookupInput) {
        if (selectedVariant.available) {
          addToCartBtn.disabled = false;
          if (buyItNowBtn) {
            buyItNowBtn.disabled = false;
          }
          addToCartBtn.textContent = addToCartBtn.dataset.textAddToCart;
        } else {
          addToCartBtn.disabled = true;
          if (buyItNowBtn) {
            buyItNowBtn.disabled = true;
          }
          addToCartBtn.textContent = addToCartBtn.dataset.textSoldOut;
        }
      } else {
        // Check if there's a selected artwork before disabling the button
        const selectedArtwork = form.querySelector('input[name^="properties[select-"]:checked');
        const sizeSelected = form.querySelector('input[name="size"]:checked') || form.querySelector('select[name="size"] option:checked');
        const colorSelected = form.querySelector('input[name="color"]:checked') || form.querySelector('select[name="color"] option:checked') || form.querySelector('input[name="colors"]:checked');
        if (selectedArtwork && sizeSelected && colorSelected) {
          addToCartBtn.disabled = false;
          if (buyItNowBtn) {
            buyItNowBtn.disabled = false;
          }
          addToCartBtn.textContent = addToCartBtn.dataset.textAddToCart;
        } else {
          addToCartBtn.disabled = true;
          if (buyItNowBtn) {
            buyItNowBtn.disabled = true;
          }
          if (!sizeSelected && !colorSelected) {
            addToCartBtn.textContent = addToCartBtn.dataset.textSelectSizeAndColor;
          } else if (!sizeSelected) {
            addToCartBtn.textContent = addToCartBtn.dataset.textSelectSize;
          } else if (!colorSelected) {
            addToCartBtn.textContent = addToCartBtn.dataset.textSelectColor;
          } else {
            addToCartBtn.textContent = selectedVariant && selectedVariant.available ? addToCartBtn.dataset.textUnavailable : addToCartBtn.dataset.textSoldOut;
          }
        }
      }

      const productPriceContainer = document.querySelector(
        `.product-price-container[data-product-id="${form.dataset.productId}`
      );

      productPriceContainer.querySelector(".product-price-final").textContent =
        window.formatMoney(selectedVariant.price);

      if (selectedVariant.compare_at_price) {
        productPriceContainer.querySelector(
          ".product-price-compare"
        ).textContent = window.formatMoney(selectedVariant.compare_at_price);
        productPriceContainer
          .querySelector(".product-price-compare")
          .classList.remove("d-none");
      } else {
        productPriceContainer
          .querySelector(".product-price-compare")
          .classList.add("d-none");
      }

      document.dispatchEvent(new CustomEvent('product-option-change', {
        detail: {
          variant: selectedVariant,
          form: form
        }
      }));

      window.history.replaceState(
        {},
        "",
        `${form.dataset.productUrl}?variant=${selectedVariant.id}&view=digital-logo-ds`
      );

      if (selectedVariant.featured_media) {
        bootstrap.Carousel.getInstance("#product-carousel").to(
          selectedVariant.featured_media.position - 1
        );
      }
    } else {
      addToCartBtn.disabled = true;
      if (buyItNowBtn) {
        buyItNowBtn.disabled = true;
      }
      addToCartBtn.textContent = addToCartBtn.dataset.textUnavailable;

      window.history.replaceState({}, "", (window.product && window.product.url) ? window.product.url : window.location.pathname);
    }

    if (logoInputs.length > 0) {
      const checkedLogoInputs = form.querySelectorAll("#product-form-logo-logo-list input:checked");
      const addToCartButton = form.querySelector('.btn-atc');

      addToCartButton.disabled = checkedLogoInputs.length < 1;
    }

  });
});

// Add to cart
if (!document.querySelector('.template-digital-boat-checkout-ds')) {
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      // Sync option-driven hidden properties from current form state.
      // Prevents stale defaults (e.g. Captain sleeve URL) when the
      // change-event listeners on options didn't run for any reason.
      const styleSelect = form.querySelector('#option-style');
      const sleeveImageInput = form.querySelector('input[name="properties[select-sleeve]"]');
      if (styleSelect && sleeveImageInput && window.styles_sleeve_images) {
        const styleKey = styleSelect.value.toLowerCase().replaceAll(' ', '-');
        if (window.styles_sleeve_images[styleKey] !== undefined) {
          sleeveImageInput.value = window.styles_sleeve_images[styleKey];
        }
      }

      const colorChecked = form.querySelector('input[name="color"]:checked, input[name="colors"]:checked');
      const frontPropsInput = form.querySelector('input[name="properties[select-front]"]');
      const backPropsInput = form.querySelector('input[name="properties[select-back]"]');
      if (colorChecked && frontPropsInput && window.front_colors_images && window.front_colors_images[colorChecked.value] !== undefined) {
        frontPropsInput.value = window.front_colors_images[colorChecked.value];
      }
      if (colorChecked && backPropsInput && window.back_colors_images && window.back_colors_images[colorChecked.value] !== undefined) {
        backPropsInput.value = window.back_colors_images[colorChecked.value];
      }

      const isBothSelected = form.querySelector("input[name='both']");

      const btn = form.querySelector('button[type="submit"]');
      const savedBtnInnerHTML = btn.innerHTML;
  
      btn.classList.add('pointer-events-none');
      btn.innerHTML = `
              <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
              </div>
          `;
  
      // Fix for Artwork product form
      const inputLogoField = form.querySelector('input[name="properties[Logo]"]');
  
      if (inputLogoField && !inputLogoField.value.length) {
        form
          .querySelector("#product-artwork-form-font-helper")
          .insertAdjacentHTML(
            "afterend",
            '<input type="hidden" name="properties[Logo]" value="">'
          );
      }

      const formData = new FormData(form);

      // If Both Option is enabled product will be added to cart twice with different styles
      if (isBothSelected) {
        const styles = formData.get("styles");
        const properties = styles.split(",");
        formData.delete("styles");
        formData.delete("both");

        formData.delete("properties[Style]");
        formData.append("properties[Style]", properties[0]);

        await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        formData.delete("properties[Style]");
        formData.append("properties[Style]", properties[1]);

        await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });
      } else {
        await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });
      }
  
      Fancybox.close();
  
      btn.classList.remove('pointer-events-none');
      btn.innerHTML = savedBtnInnerHTML;
      btn.blur();
  
      const offcanvas = new bootstrap.Offcanvas(
        document.querySelector("#offcanvas-cart")
      );
      offcanvas.show();
  
      const docResponse = await fetch(window.location.href);
      const docData = await docResponse.text();
  
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(docData, "text/html");
  
      document.querySelectorAll(".navbar-icons-cart .badge").forEach((el) => {
        el.replaceWith(newDocument.querySelector(`#${el.id}`));
      });
  
      document
        .querySelector("#offcanvas-cart-inner")
        ?.replaceWith(newDocument.querySelector("#offcanvas-cart-inner"));
  
      window.initCartQty();
  
      const $form = document.querySelector("#product-form-logo-ds");
      if ($form) {
        const addToCartButton = $form.querySelector('.btn-atc');
        addToCartButton.disabled = true;
    
        // Clear FilePond instance
        if (pondPhoto) {
          pondPhoto.removeFiles();
        }
    
        const popUpFields = [
          ...$form.querySelectorAll('input'),
          ...$form.querySelectorAll('textarea'),
        ];
    
        clearInputValues(popUpFields);
        
        // Reset the form state variables
        firstField = false;
        secondField = false;
        thirdField = false;
        disableCartButton = true;
    
        // Reset any active logo options
        removeActivePageLogoOptions();
      }
    });
  });
}

// 'Buy it now' buttons
document.querySelectorAll(".btn-buy-it-now").forEach((btn) => {
  btn.addEventListener("click", () => {
    const form = btn.closest('form[action="/cart/add"]');
    const variantId = form.querySelector('select[name="id"]').value;
    const qty = Number(form.querySelector('input[name="quantity"]').value || 1);
    window.location.href = `/cart/${variantId}:${qty}`;
  });
});

// Product Carousel - Sticky position
const productCarousel = document.querySelector("#product-carousel");

if (productCarousel) {
  const navbarHeight =
    document.querySelector("#shopify-section-navbar.sticky-top")?.clientHeight ||
    0;

  productCarousel.style.position = "sticky";
  productCarousel.style.top = `${navbarHeight + 20}px`;
}

// Recommended products
const initRecommendedProducts = () => {
  const recommendedProducts = document.querySelector("#recommended-products");
  if (recommendedProducts) {
    const { sectionId, baseUrl, productId, limit } =
      recommendedProducts.dataset;
    const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;
    fetch(url)
      .then((response) => response.text())
      .then((data) => {
        recommendedProducts.closest(".shopify-section").outerHTML = data;
        document
          .querySelectorAll('[data-bs-toggle="popover"]')
          .forEach((el) => new bootstrap.Popover(el));
        window.restartProductListItemsAnimation();
      });
  }
};
initRecommendedProducts();

document.addEventListener("shopify:section:load", (e) => {
  const { sectionId } = e.target.querySelector("#recommended-products").dataset;
  if (e.detail.sectionId === sectionId) {
    initRecommendedProducts();
  }
});

// Artwork Product Form
const initArtWorkProductForm = () => {
  const $form = document.querySelector("#product-form-artwork");

  if (!$form) {
    return;
  }

  const bothInput = $form.querySelector("#product-form-artwork-style-3");
  const bothValue = bothInput ? bothInput.value : null;
  const properties = $form.querySelectorAll("input[name='properties[Style]']");
  const propertiesValues = [];
  let isBothSelected = false;
  
  const priceEl = document.querySelector(".product-main__price-container");
  const originalPriceHTML = priceEl.innerHTML;
  const productPrice = bothInput ? bothInput.getAttribute("data-product-price") : null;
  const productCompareAtPrice = bothInput ? bothInput.getAttribute("data-product-compare-at-price") : null;
  const productBothDiscount = bothInput ? bothInput.getAttribute("data-product-both-discount").replace(/[^\d]/g, '') : null;

  properties.forEach((property) => {
    propertiesValues.push(property.value);
  });

  const addHiddenInputs = () => {
    const inputStyles = document.createElement("input");
    inputStyles.type = "hidden";
    inputStyles.name = "styles";
    inputStyles.value = propertiesValues;
    $form.appendChild(inputStyles);

    const inputBoth = document.createElement("input");
    inputBoth.type = "hidden";
    inputBoth.name = "both";
    inputBoth.value = true;
    $form.appendChild(inputBoth);
  }

  const removeHiddenInputs = () => {
    const stylesInput = $form.querySelector("input[name='styles']");
    if (stylesInput) stylesInput.remove();

    const bothInput = $form.querySelector("input[name='both']");
    if (bothInput) bothInput.remove();
  } 

  NiceSelect.bind(document.querySelector("#product-artwork-form-font-select"));

  // $form.querySelector('[data-step-0] .btn-next').addEventListener('click', () => {
  //     $form.querySelector('[data-step-0]').style.display = 'none'
  //     $form.querySelector('[data-step-1]').style.display = 'block'
  // })

  $form.querySelectorAll('input[name="properties[Style]"]').forEach(($el) => {
    $el.addEventListener("change", (e) => {
      if (bothInput && bothValue) {
        if (e.target.value === bothValue) {
          isBothSelected = true;
          priceEl.innerHTML = `<s class="product-main__price-compare">
            <span class="visually-hidden">Old price</span>$${(productCompareAtPrice * 2).toFixed(2)}</s><span class="igPrice">$${((productPrice * 2) - productBothDiscount).toFixed(2)}</span>`
        } else {
          isBothSelected = false;
          priceEl.innerHTML = originalPriceHTML;
        }
      }

      const carouselImages = document.querySelectorAll('#product-carousel .product-carousel-img');

      carouselImages.forEach((image, index) => {
        const imageAltText = image.getAttribute('alt');
        if ($el.value === imageAltText) {
          bootstrap.Carousel.getInstance("#product-carousel").to(index);
          return;
        }
      });
      
      $form.querySelector("[data-step-1] .btn-next").disabled = false;
    });
  });
  const step1NextBtn = $form.querySelector("[data-step-1] .btn-next");
  if (step1NextBtn) {
    step1NextBtn.addEventListener("click", () => {
      $form.querySelector("[data-step-1]").style.display = "none";
      $form.querySelector("[data-step-2]").style.display = "block";

      document.getElementById("product-form-artwork").scrollIntoView();
    });
  }

  FilePond.registerPlugin(FilePondPluginImagePreview);

  const $photoFileInput = $form.querySelector(
    'input[name="properties[Photo]"]'
  );

  const pondPhoto = FilePond.create($photoFileInput, {
    storeAsFile: true,
    labelIdle: `<span class="filepond--drop-label--icon me-3"></span> ${$photoFileInput.dataset.label} <span class="filepond--label-action ms-1">Browse</span>`,
  });

  pondPhoto.on("addfile", (error) => {
    if (!error) {
      if ($form.classList.contains("existing-artwork-digitalization")) {
        $form.querySelector("[data-step-1] .btn-next").disabled = false;
      } else {
        $form.querySelector("[data-step-2] .btn-next").disabled = false;
      }
    }
  });

  pondPhoto.on("removefile", (error) => {
    if (!error) {
      if ($form.classList.contains("existing-artwork-digitalization")) {
        $form.querySelector("[data-step-1] .btn-next").disabled = true;
      } else {
        $form.querySelector("[data-step-2] .btn-next").disabled = true;
      }
    }
  });

  const $fontSelect = $form.querySelector("#product-artwork-form-font-select");
  const $fontPreview = $form.querySelector(
    "#product-artwork-form-font-preview"
  );
  const $fontHelper = $form.querySelector("#product-artwork-form-font-helper");

  const $logoFileInput = $form.querySelector('input[name="properties[Logo]"]');
  const $logoFileWrapper = $logoFileInput.closest(".filepond-wrapper");

  const $inputTextBoat = $form.querySelector('input[name="properties[Boat]"]');
  const $inputTextPort = $form.querySelector('input[name="properties[Port]"]');

  FilePond.create($logoFileInput, {
    storeAsFile: true,
    labelIdle: `<span class="filepond--drop-label--icon me-3"></span> ${$logoFileInput.dataset.label} <span class="filepond--label-action ms-1">Browse</span>`,
    files: [],
  });

  $fontSelect.addEventListener("change", () => {
    if ($fontSelect.value === "logo-upload") {
      $logoFileWrapper.style.display = "block";
      $fontPreview.style.display = "none";
      $fontHelper.style.display = "none";
      $fontPreview.textContent = "";
      $inputTextBoat.style.display = "none";
      $inputTextPort.style.display = "none";
    } else if ($fontSelect.value.length) {
      $fontPreview.style.display = "none";
      $fontHelper.style.display = "block";
      $logoFileWrapper.style.display = "none";
      $fontPreview.textContent =
        $fontSelect.options[$fontSelect.selectedIndex].text;
      $fontPreview.style.fontFamily = `"${$fontSelect.value}", sans-serif`;
      $inputTextBoat.style.display = "block";
      $inputTextPort.style.display = "block";
    } else {
      $fontPreview.style.display = "none";
      $fontHelper.style.display = "none";
      $logoFileWrapper.style.display = "none";
      $fontPreview.textContent = "";
      $inputTextBoat.style.display = "block";
      $inputTextPort.style.display = "block";
    }
  });

  const step2NextBtn = $form.querySelector("[data-step-2] .btn-next");
  if (step2NextBtn) {
    step2NextBtn.addEventListener("click", () => {
      $form.querySelector("[data-step-2]").style.display = "none";
      $form.querySelector("[data-step-3]").style.display = "block";
      document.getElementById("product-form-artwork").scrollIntoView();
      isBothSelected ? addHiddenInputs() : removeHiddenInputs();
    });
  }

  const step2BackBtn = $form.querySelector("[data-step-2] .btn-go-back");
  if (step2BackBtn) {
    step2BackBtn.addEventListener("click", () => {
      $form.querySelector("[data-step-2]").style.display = "none";
      
      if ($form.classList.contains("existing-artwork-digitalization")) {
        $form.querySelector("[data-step-1]").style.display = "block";
      } else {
        $form.querySelector("[data-step-1]").style.display = "flex";
      }

      document.getElementById("product-form-artwork").scrollIntoView();
    });
  }

  // Handle step 3 back button - check if it exists (only in regular form)
  const step3BackBtn = $form.querySelector("[data-step-3] .btn-go-back");
  if (step3BackBtn) {
    step3BackBtn.addEventListener("click", () => {
      $form.querySelector("[data-step-3]").style.display = "none";
      $form.querySelector("[data-step-2]").style.display = "block";

      document.getElementById("product-form-artwork").scrollIntoView();
    });
  }
};
initArtWorkProductForm();

// Logo Product Form
const initLogoProductForm = () => {
  const $form = document.querySelector("#product-form-logo");
  if (!$form) return;

  let is5FilesUploaded = false;
  
  let preferredLogosArray = [];

  FilePond.registerPlugin(FilePondPluginImagePreview);

  // Create container for FilePond instances
  const filepondsContainer = document.createElement('div');
  filepondsContainer.id = 'fileponds-container';
  
  // Insert container after the main file input
  const inputPhotosElem = document.querySelector("#Photos");
  inputPhotosElem.parentNode.insertBefore(filepondsContainer, inputPhotosElem.nextSibling);

  // Hide the original input after creating FilePond instances
  inputPhotosElem.style.display = 'none';

  // Setup drag and drop zone
  const dragDropZone = document.querySelector('.ds-input-file-wrapper');
  let isDialogOpen = false;

  dragDropZone.addEventListener('dragover', (e) => {
    e.preventDefault();
    dragDropZone.classList.add('drag-over');
  });

  dragDropZone.addEventListener('dragleave', (e) => {
    e.preventDefault();
    dragDropZone.classList.remove('drag-over');
  });

  dragDropZone.addEventListener('drop', (e) => {
    e.preventDefault();
    dragDropZone.classList.remove('drag-over');
    const files = e.dataTransfer.files;

    const newInputs = document.querySelectorAll('.js-new-file-input');
    is5FilesUploaded = newInputs.length >= 5;
    
    if (!is5FilesUploaded) {
      handleFiles(files);
    } else {
      alert('Limit exceeded - maximum 5 files');
    }
  });

  // Modified click handler
  dragDropZone.addEventListener('click', (e) => {
    e.preventDefault();
    inputPhotosElem.click();
  });

  // Modified input change handler
  inputPhotosElem.addEventListener('click', () => {
    // Reset the input value to ensure change event fires even with same file
    inputPhotosElem.value = '';
  });

  inputPhotosElem.addEventListener('change', (event) => {
    const newInputs = document.querySelectorAll('.js-new-file-input');
    is5FilesUploaded = newInputs.length >= 5;

    if (is5FilesUploaded) {
      alert('Limit exceeded - maximum 5 files');
      return;
    };

    if (event.target.files.length > 0) {
      if (event.target.files.length <= 5) {
        handleFiles(event.target.files);
      } else {
        alert('Limit exceeded - maximum 5 files')
      }
    }
  });

  // Common function to handle files from both drag&drop and file input
  const handleFiles = (files) => {
    Array.from(files).forEach((file) => {
      // Create hidden input for Shopify
      const newInput = document.createElement('input');
      newInput.type = 'file';
      newInput.name = `properties[Image ${$form.querySelectorAll('input[name^="properties[Image "]').length + 1}]`;
      newInput.classList.add('js-new-file-input');
      newInput.style.display = 'none';
      
      // Create a new FileList-like object with just this file
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      newInput.files = dataTransfer.files;
      
      $form.appendChild(newInput);

      // Create FilePond instance
      const pondInput = document.createElement('input');
      pondInput.type = 'file';
      pondInput.className = 'filepond-input';
      filepondsContainer.appendChild(pondInput);

      const pond = FilePond.create(pondInput, {
        files: [{
          source: file,
          options: {
            type: 'local'
          }
        }],
        storeAsFile: true,
        allowMultiple: false,
        allowReorder: false,
        allowRemove: true,
        allowProcess: false,
        labelIdle: `Image ${$form.querySelectorAll('input[name^="properties[Image "]').length}`,
        className: 'mb-3',
        onremovefile: (error, file) => {
          // Remove corresponding hidden input
          const imageNumber = pond.labelIdle.match(/Image (\d+)/)[1];
          const hiddenInput = $form.querySelector(`input[name="properties[Image ${imageNumber}]"]`);
          if (hiddenInput) {
            hiddenInput.remove();
          }
          // Remove the FilePond instance and its container
          pond.destroy();
          pondInput.remove();
        }
      });
    });

    // Enable next button if we have files and text area is filled
  };


  // Add some CSS for drag and drop visual feedback
  const style = document.createElement('style');
  style.textContent = `
    .ds-input-file-wrapper.drag-over {
      border: 2px dashed var(--bs-primary);
      background-color: rgba(var(--bs-primary-rgb), 0.1);
    }
  `;
  document.head.appendChild(style);

  $form
    .querySelector("#product-form-logo-name")
    ?.addEventListener("input", (event) => {
      if (event.target.value) {
        $form.querySelector("[data-step-1] .btn-next").disabled = false;
      } else {
        $form.querySelector("[data-step-1] .btn-next").disabled = true;
      }
    });

  $form
    .querySelector("[data-step-1] .btn-next")
    .addEventListener("click", () => {
      $form.querySelector("[data-step-1]").style.display = "none";
      $form.querySelector("[data-step-2]").style.display = "block";

      document.getElementById("product-content-area").scrollIntoView();
    });

  $form
    .querySelector("[data-step-2] .btn-next")
    .addEventListener("click", () => {
      $form.querySelector("[data-step-2]").style.display = "none";
      $form.querySelector("[data-step-3]").style.display = "block";

      document.getElementById("product-content-area").scrollIntoView();
    });

  $form
  .querySelector("[data-step-2] .btn-go-back")
  .addEventListener("click", () => {
    $form.querySelector("[data-step-2]").style.display = "none";
    $form.querySelector("[data-step-1]").style.display = "block";

    document.getElementById("product-content-area").scrollIntoView();
  });
  
  $form
  .querySelector("[data-step-3] .btn-go-back")
  .addEventListener("click", () => {
    $form.querySelector("[data-step-3]").style.display = "none";
    $form.querySelector("[data-step-2]").style.display = "block";

    document.getElementById("product-content-area").scrollIntoView();
  });
  
  $form.querySelector("#product-form-logo-input-details")?.addEventListener("input", () => {
    const textAreaValue = $form.querySelector("#product-form-logo-input-details").value.trim();
    if (textAreaValue && textAreaValue.length > 0) {
        $form.querySelector("[data-step-2] .btn-next").disabled = false;
    } else {
        $form.querySelector("[data-step-2] .btn-next").disabled = true;
    }
  });

  $form
    .querySelectorAll("#product-form-logo-logo-list input")
    .forEach((input) => {
      input.addEventListener("change", () => {
        if (
          $form.querySelectorAll("#product-form-logo-logo-list input:checked")
            .length >= 3
        ) {
          $form
            .querySelectorAll(
              "#product-form-logo-logo-list input:not(:checked) + label"
            )
            .forEach((label) => {
              const currentItem = label.closest('li');
              const currentInput = currentItem.querySelector('input');

              currentInput.disabled = true;
              label.style.opacity = 0.25;
              label.style.pointerEvents = 'none';
            });
        } else {
          $form
            .querySelectorAll(
              "#product-form-logo-logo-list input:not(:checked) + label"
            )
            .forEach((label) => {
              const currentItem = label.closest('li');
              const currentInput = currentItem.querySelector('input');

              currentInput.disabled = false;
              label.style.opacity = 1;
              label.style.pointerEvents = 'auto';
            });
        }

        if (input.checked) {
          preferredLogosArray.push(input.value);
        } else {
          preferredLogosArray = preferredLogosArray.filter(
            (elem) => elem !== input.value
          );
        }

        const addToCartButton = $form.querySelector('.btn-atc');

        addToCartButton.disabled = $form.querySelectorAll("#product-form-logo-logo-list input:checked").length < 1;

        $form.querySelector('[name="properties[Preferred Logos]"]').value =
          preferredLogosArray.toString();
      });
    });

  $form
    .querySelector("[data-step-3] .btn-go-back")
    .addEventListener("click", () => {
      $form.querySelector("[data-step-3]").style.display = "none";
      $form.querySelector("[data-step-2]").style.display = "block";
    });
};
initLogoProductForm();

const triggerChangeEvent = (element) => {
  const event = new Event('change', {
    bubbles: true,
    cancelable: true
  });
  element.dispatchEvent(event);
};

// Logo Product Form DS
const initLogoProductFormDS = () => {
  const $form = document.querySelector("#product-form-logo-ds");
  if (!$form) return;
  const addToCartButton = $form.querySelector('.btn-atc');


  const removeChackedOptions = () => {
    $form.querySelectorAll(".product-option-ds").forEach((option) => {
      if (option.selected) {
        option.selected = false;
      }
    });
  }

  const pageLogoOptions = [...document.querySelectorAll('.page-logo-option')];

  if (pageLogoOptions.length > 0) {
    pageLogoOptions.forEach((logoOption) => {
      logoOption.addEventListener("click", (e) => {
        $form.querySelectorAll(".product-option-ds").forEach((option) => {

          if (e.target.dataset.optionName == option.id && !e.target.classList.contains('active')) {
            removeChackedOptions();
            option.selected = true;
            triggerChangeEvent(option);
            removeActivePageLogoOptions();
            e.target.classList.add('active');
            e.target.closest('.option-buttons__item').classList.add('active');
          }
        });
      });
    })
  }

  let preferredLogosArray = [];

  $form.querySelector("#product-form-logo-input-details")?.addEventListener("input", () => {
    const textAreaValue = $form.querySelector("#product-form-logo-input-details").value.trim();
  });

  FilePond.registerPlugin(FilePondPluginImagePreview);

  const inputPhotosElem = document.querySelector(
    "#product-form-logo-input-photos"
  );

  const pondPhoto = FilePond.create(inputPhotosElem, {
    storeAsFile: true,
    labelIdle: `<span class="filepond--drop-label--icon me-3"></span> Upload your file <span class="filepond--label-action ms-1">Browse</span>`,
    onremovefile: (error, file) => {
      if (!error) {
        // Reset form state when file is removed
        const addToCartButton = $form.querySelector('.btn-atc');
        addToCartButton.disabled = true;
        
        // Only reset secondField if there are no files left
        if (pondPhoto.getFiles().length === 0) {
          secondField = false;
        }
        
        // Update button state
        if (!disableCartButton && firstField && secondField && thirdField) {
          addToCartButton.disabled = false;
        } else {
          addToCartButton.disabled = true;
        }
      }
    },
    onaddfile: (error, file) => {
      if (!error) {
        console.log('File added to form:', file.file);
        secondField = true;
        
        // Update button state
        const addToCartButton = $form.querySelector('.btn-atc');
        if (!disableCartButton && firstField && secondField && thirdField) {
          addToCartButton.disabled = false;
        } else {
          addToCartButton.disabled = true;
        }
      }
    }
  });

  $form
    .querySelector("#product-form-logo-name")
    ?.addEventListener("input", (event) => {
      if (event.target.value) {
        firstField = true;
      } else {
        firstField = false;
      }

      if (!disableCartButton && firstField && secondField && thirdField) {
        addToCartButton.disabled = false;
      } else {
        addToCartButton.disabled = true;
      }
    });

  $form
  .querySelector("#product-form-logo-port")
  ?.addEventListener("input", (event) => {
    if (event.target.value) {
      thirdField = true;
    } else {
      thirdField = false;
    }

    if (!disableCartButton && firstField && secondField && thirdField) {
      addToCartButton.disabled = false;
    } else {
      addToCartButton.disabled = true;
    }
  });

  $form.querySelector("#product-form-logo-input-details")?.addEventListener("input", () => {
    const textAreaValue = $form.querySelector("#product-form-logo-input-details").value.trim();

    if (textAreaValue && textAreaValue.length > 0) {
      secondField = true;
    } else {
      secondField = false;
    }

    if (!disableCartButton && firstField && secondField && thirdField) {
      addToCartButton.disabled = false;
    } else {
      addToCartButton.disabled = true;
    }
  });

  $form
    .querySelectorAll("#product-form-logo-logo-list input")
    .forEach((input) => {
      input.addEventListener("change", () => {
        if (
          $form.querySelectorAll("#product-form-logo-logo-list input:checked")
            .length >= 3
        ) {
          $form
            .querySelectorAll(
              "#product-form-logo-logo-list input:not(:checked) + label"
            )
            .forEach((label) => {
              const currentItem = label.closest('li');
              const currentInput = currentItem.querySelector('input');

              currentInput.disabled = true;
              label.style.opacity = 0.25;
              label.style.pointerEvents = 'none';
            });
        } else {
          $form
            .querySelectorAll(
              "#product-form-logo-logo-list input:not(:checked) + label"
            )
            .forEach((label) => {
              const currentItem = label.closest('li');
              const currentInput = currentItem.querySelector('input');

              currentInput.disabled = false;
              label.style.opacity = 1;
              label.style.pointerEvents = 'auto';
            });
        }

        if (input.checked) {
          preferredLogosArray.push(input.value);
        } else {
          preferredLogosArray = preferredLogosArray.filter(
            (elem) => elem !== input.value
          );
        }

        disableCartButton = $form.querySelectorAll("#product-form-logo-logo-list input:checked").length < 1;

        if (!disableCartButton && firstField && secondField && thirdField) {
          addToCartButton.disabled = false;
        } else {
          addToCartButton.disabled = true;
        }

        $form.querySelector('[name="properties[Preferred Logos]"]').value =
          preferredLogosArray.toString();
        });
    });
};
initLogoProductFormDS();


document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    // Find all forms that might be product forms
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    
    productForms.forEach(function(form) {
      // Check if the form has an oldId but no id field
      const oldIdSelect = form.querySelector('select[name="oldId"]');
      const idField = form.querySelector('[name="id"]');
      
      if (oldIdSelect && !idField) {
        // Rename the oldId field back to id
        oldIdSelect.setAttribute('name', 'id');
        console.log('Fixed a product form by renaming oldId to id');
      }
      
      // Also check for hidden inputs with name="oldId"
      const oldIdInput = form.querySelector('input[name="oldId"]');
      if (oldIdInput && !idField) {
        oldIdInput.setAttribute('name', 'id');
        console.log('Fixed a product form by renaming oldId input to id');
      }
    });
  }, 2000);
});